import * as vec3 from '@antv/gl-matrix/lib/gl-matrix/vec3';
export default vec3;
//# sourceMappingURL=vec3.js.map